@if (sites.length > 0) {
    <div class="site-selector" [class.dark]="theme === 'dark'">
        <label class="me-2">Site:</label>
        <select
            class="form-select form-select-sm"
            [ngModel]="selectedSiteId"
            (ngModelChange)="onSiteChange($event)">
            @for (site of sites; track site.id) {
                <option [value]="site.id">{{ displayName(site) }}</option>
            }
        </select>
    </div>
}
